import { IDanhSachSinhVienTinChiViewModel } from "../../../model/respone/lop-tin-chi/IDanhSachSinhVienTinChiViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IDanhSachLopTinChiActionTypes<T> {
    id: number,
    data: T
}
export const eDanhSachLopTinChiActionsObj = {
    ADD_LOP_TIN_CHI: 0,
    LOAD_START: 0,
    LOAD_SUCCESS: {} as IDanhSachLopTinChiActionTypes<IDanhSachSinhVienTinChiViewModel[]>,
    LOAD_ERROR: {} as IDanhSachLopTinChiActionTypes<string>,

};

export const eDanhSachLopTinChiActionIds = generateActionTypeIds(eDanhSachLopTinChiActionsObj, "DANH_SACH_LOP_TC");
export type IDanhSachLopTinChiActions = IGenericActionType<typeof eDanhSachLopTinChiActionsObj, "DANH_SACH_LOP_TC">;